import { HHTooltip } from '@hinge-health/react-component-library';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { GridActionsCellItem } from '@mui/x-data-grid';

// The Copy modal is owned by the grid (useRuleActionModals), not the cell
export const CopyActionButton = ({
  onClick,
  copyRuleLoading,
}: {
  onClick: () => void;
  copyRuleLoading: boolean;
}): JSX.Element => (
  <HHTooltip hhVariant="bottom" title="Copy">
    <GridActionsCellItem
      id="copy-rule-button"
      data-testid="copy-rule-button"
      label="Copy"
      icon={<CopyAllIcon />}
      color="primary"
      onClick={onClick}
      disabled={copyRuleLoading}
    />
  </HHTooltip>
);
